import { ECommonEntityStatus, ECommonEntityStatusText } from "entities/Bitecoin/Bitecoin.models";

export const getCommonEntityStatusText = (status: ECommonEntityStatus) => {
  switch (status) {
    case ECommonEntityStatus.Inactive:
      return ECommonEntityStatusText.Inactive;
    case ECommonEntityStatus.Active:
      return ECommonEntityStatusText.Active;
    case ECommonEntityStatus.Archived:
      return ECommonEntityStatusText.Archived;
    default:
      return '-';
  }
};
